<template>
    <div>
        <div class="lineChart" :id=cId :style="customerStyle"></div>
    </div>
</template>

<script>
export default {
    props: {
        cId: {
            type: String,
            default: ''
        },
        customerStyle: String,
        unit: String
    },
    setup() {
        const myChart = null
        return {
            myChart
        }
    },
    methods: {
        initChart(data) {
            setTimeout(() => {
                this.drawChart(data)
            },100)
        },
        drawChart(data) {
            if (this.myChart != null) {
                //如果非初始化，则释放画布，以免造成重复加载
                this.myChart.dispose()
            }
            // 基于准备好的dom，初始化echarts实例
            const myChart = this.$root.$echarts.init(document.getElementById(this.cId))
            this.myChart = myChart
            // 指定图表的配置项和数据
            const option = {
                color: ['#F6921E', '#03AA35', '#F03D42', '#95F3EB', '#1A8FA4'],
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b}: {c}家 ({d}%)'
                },
                legend: {
                    orient: 'horizontal',
                    // right: 'left',
                    bottom: 'top',
                    textStyle: {
                        color: '#00c6fc'
                    }
                },
                grid: {
                    top: '1%',
                    right: '1%',
                    left: '1%',
                    bottom: '1%'
                },
                series: [
                    {
                        name: '主体统计',
                        type: 'pie',
                        radius: '50%',
                        data: data,
                        label: {
                            formatter: '{b|{b}}{c}家',
                            backgroundColor: '#41f5fb',
                            borderColor: '#00c6fc',
                            borderWidth: 1,
                            borderRadius: 4,
                            // shadowBlur:3,
                            // shadowOffsetX: 2,
                            // shadowOffsetY: 2,
                            // shadowColor: '#999',
                            padding: [4, 8],
                            rich: {
                                a: {
                                    color: '#FFF',
                                    lineHeight: 22,
                                    align: 'center'
                                },
                            }
                        },
                        // label: {
                        //     normal: {
                        //         textStyle: {
                        //             color: '#00c6fc'  // 改变标示文字的颜色
                        //         }
                        //     }
                        // },
                    }
                ]
            }

            myChart.setOption(option)
            myChart.resize()
        }
    },
    watch: {
        chartData() {
            this.initChart()
        }
    }
}
</script>

<style scoped>
.lineChart {
    height: 100%;
}
</style>